import { Button as SemanticButton } from 'semantic-ui-react';
import styled from 'styled-components';

export const Container = styled.div`
  min-height: 250px;
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
`;

export const Header = styled.div`
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #EBEBEB;
  margin-bottom: 10px;
  -webkit-app-region: drag;
`;

export const RecordingSign = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
  background-color: #FB5E5E;
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
`;

export const Recorder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;

export const Step = styled.div`
  color: #A3A3A3;
  font-size: 12px;
`;

export const Control = styled.div`
  cursor: pointer;
  -webkit-app-region: no-drag;

  span {
    color: #477AE9;
    font-size: 12px;

    :hover {
      color: #1954D3;
    }

    :active {
      color: #123C96;
    }
  }
`;

export const Content = styled.div`
  width: 100%;
  max-height: 150px;
  padding: 5px;
  overflow-y: auto;
`;

export const BottomButtonContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: auto;
`;

export const ErrorMessage = styled.div`
  margin-right: 10px;
  color: red;
`;

export const BottomButton = styled(SemanticButton)`
  &.ui.button {
    background: #477AE9;
    border-radius: 3px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    color: #FFFFFF;
    font-weight: 500;
    height: 35px;
    margin: 0px;
    min-width: 100px;
    padding-left: 15px;
    padding-right: 15px;

    :hover {
      background: #1954D3;
    }

    :active {
      background: #123C96;
    }
  }
`;
